/** Campaign information is descriptive, never authority for agency eligibility. */
import { v } from "convex/values";

export const attributionValidator = v.object({
  consent: v.boolean(), landing_path: v.optional(v.string()), referrer_host: v.optional(v.string()),
  utm_source: v.optional(v.string()), utm_medium: v.optional(v.string()), utm_campaign: v.optional(v.string()),
  utm_content: v.optional(v.string()), utm_term: v.optional(v.string()),
});
export interface Attribution {
  consent: boolean; landing_path?: string; referrer_host?: string;
  utm_source?: string; utm_medium?: string; utm_campaign?: string; utm_content?: string; utm_term?: string;
}
export function normalizeAttribution(input?: Attribution): Attribution {
  if (!input?.consent) return { consent: false };
  const clean = (s?: string) => s?.replace(/[<>\u0000-\u001f]/g, "").trim().slice(0, 200) || undefined;
  const landing = clean(input.landing_path);
  const host = input.referrer_host?.trim().toLowerCase();
  return { consent: true,
    landing_path: landing?.startsWith("/") && !landing.startsWith("//") ? landing.split(/[?#]/)[0] : undefined,
    referrer_host: host && /^(?=.{1,253}$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/.test(host) ? host : undefined,
    utm_source: clean(input.utm_source), utm_medium: clean(input.utm_medium), utm_campaign: clean(input.utm_campaign),
    utm_content: clean(input.utm_content), utm_term: clean(input.utm_term) };
}
export const SOCIAL_CHANNELS = [
  {source:"instagram",id:"A1_INSTAGRAM",label:"Instagram",aliases:["instagram","ig"],domains:["instagram.com"]},
  {source:"linkedin",id:"A1_LINKEDIN",label:"LinkedIn",aliases:["linkedin","li"],domains:["linkedin.com","lnkd.in"]},
  {source:"youtube",id:"A1_YOUTUBE",label:"YouTube",aliases:["youtube","yt"],domains:["youtube.com","youtu.be"]},
  {source:"facebook",id:"A1_FACEBOOK",label:"Facebook",aliases:["facebook","fb","meta"],domains:["facebook.com","fb.com"]},
  {source:"tiktok",id:"A1_TIKTOK",label:"TikTok",aliases:["tiktok"],domains:["tiktok.com"]},
  {source:"x",id:"A1_X",label:"X / Twitter",aliases:["x","twitter"],domains:["x.com","twitter.com","t.co"]},
] as const;
export function leadSource(input?: Attribution):string {
  const a=normalizeAttribution(input),source=a.utm_source?.toLowerCase(),host=a.referrer_host??"";
  const explicit=SOCIAL_CHANNELS.find(channel=>channel.aliases.some(alias=>alias===source));
  if(explicit)return explicit.id;
  if(["social","redes_sociales"].includes(source??""))return "A1_SOCIAL";
  if(["idealista","fotocasa"].includes(source??""))return "A1_PORTALS";
  const domain=(name:string)=>host===name||host.endsWith(`.${name}`);
  const referred=SOCIAL_CHANNELS.find(channel=>channel.domains.some(domain));
  if(referred)return referred.id;
  if(domain("idealista.com")||domain("fotocasa.es"))return "A1_PORTALS";
  // An agency/partner URL tag must not assert a signed agreement or attach an agency.
  return "WEB";
}
export const SOURCE_NAMES: Record<string, string> = { WEB: "Página web", A1_INSTAGRAM: "Instagram", A1_SOCIAL: "Redes sociales",
  A1_LINKEDIN: "LinkedIn", A1_YOUTUBE: "YouTube", A1_FACEBOOK: "Facebook", A1_TIKTOK: "TikTok", A1_X: "X / Twitter",
  A1_PORTALS: "Portales inmobiliarios", A1_IDEALISTA: "Idealista", A1_AGENCY: "Agencia colaboradora", A1_PARTNER: "Partner",
  RECOMMENDATION: "Referido", CALL: "Llamada / oficina", OTHER: "Otros", EMAIL: "Email", WEBFORM: "Formulario CRM" };
